import * as z from "zod";

export type InviteStaffFormValues = {
    firstName: string;
    lastName: string;
    email: string;
    company?: string;
    jobTitle?: string;
    phone?: string;
    address1?: string;
    address2?: string;
    city?: string;
    country?: string;
    postCode?: string;
    role: number;
};

export const formSchema: z.ZodType<InviteStaffFormValues> = z.object({
    firstName: z.string().nonempty({ message: "First name is required." }),
    lastName: z.string().nonempty({ message: "Last name is required." }),
    email: z.string().email({ message: "Please enter valid email address." }),
    company: z.string().optional(),
    jobTitle: z.string().optional(),
    phone: z.string().optional(),
    address1: z.string().nonempty({ message: "Address 1 is required." }),
    address2: z.string().optional(),
    city: z.string().optional(),
    country: z.string().nonempty({ message: "Country is required." }),
    postCode: z.string().optional(),
    role: z.number().min(1, { message: "Role is required." }),
});
